import React from 'react';
import { Create } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const StateLocationTypePositionRateSettingCreate = () => (
  <Create
    transform={getTransform(
      ['location_type_id', 'state_id'],
      'state_location_type_position_rate_setting',
    )}
  >
    <PositionRateSettingsForm settingsField="state_location_type_position_rate_setting" />
  </Create>
);

export default StateLocationTypePositionRateSettingCreate;
